<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>

    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.type"
              placeholder="请选择任务类型"
              clearable
              style="width: 100%"
            >
              <el-option
                value="1"
                label="循环执行"
              />
              <el-option
                value="2"
                label="单次执行"
              />
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="masterList.tableQuery.beanName"
              placeholder="请输入Spring Bean名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="masterList.tableQuery.methodName"
              placeholder="请输入任务方法名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="4">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top: 5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-cell-background="masterList.cellBackground"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="handleAdd"
        @edit="handleEdit(arguments)"
        @run="handleRun(arguments)"
        @pause="handlePause(arguments)"
        @resume="handleResume(arguments)"
        @delete="handleDelete(arguments)"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
      />
    </div>

    <!-- 新增/修改 -->
    <el-dialog
      v-if="dialogAddEditVisible"
      :title="dialogAddEditTitle"
      :visible.sync="dialogAddEditVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
      append-to-body
      class="el-dialog-sm"
    >
      <el-form
        ref="dialogAddEditForm"
        :model="dialogAddEditForm"
        :rules="dialogAddEditFormRules"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            定时任务信息
          </h3>
          <div class="modal-row-box">
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="任务类型"
                  prop="type"
                >
                  <el-radio-group v-model="dialogAddEditForm.type">
                    <el-radio :label="1">
                      循环执行
                    </el-radio>
                    <el-radio :label="2">
                      单次执行
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="Bean名称"
                  prop="beanName"
                >
                  <el-input
                    v-model="dialogAddEditForm.beanName"
                    maxlength="256"
                    clearable
                    autofocus
                    placeholder="请输入Spring Bean名称"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="Method名称"
                  prop="methodName"
                >
                  <el-input
                    v-model="dialogAddEditForm.methodName"
                    maxlength="128"
                    clearable
                    autofocus
                    placeholder="请输入Spring Method名称"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="参数"
                  prop="params"
                >
                  <el-input
                    v-model="dialogAddEditForm.params"
                    maxlength="512"
                    type="textarea"
                    placeholder="请输入参数"
                    :autosize="{minRows: 2, maxRows: 5}"
                    resize="none"
                    style="margin-top: -8px;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="Cron表达式"
                  prop="cronExpression"
                >
                  <el-input
                    v-model="dialogAddEditForm.cronExpression"
                    maxlength="64"
                    clearable
                    autofocus
                    placeholder="请输入Cron表达式"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="备注"
                  prop="remark"
                >
                  <el-input
                    v-model="dialogAddEditForm.remark"
                    type="textarea"
                    resize="none"
                    clearable
                    maxlength="128"
                    placeholder="请输入备注"
                    style="margin-top: -8px;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">
          关闭
        </el-button>
        <el-button
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 查看 -->
    <el-dialog
      v-if="dialogViewVisible"
      :title="dialogViewTitle"
      :visible.sync="dialogViewVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      destroy-on-close
      append-to-body
      class="el-dialog-sm"
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
      >
        <div class="modal-box">
          <h3 class="modal-title">
            定时任务信息
          </h3>
          <div class="modal-row-box">
            <el-row>
              <el-col :span="24">
                <el-form-item label="任务类型">
                  <el-radio-group
                    v-model="dialogViewForm.type"
                    disabled
                  >
                    <el-radio :label="1">
                      循环执行
                    </el-radio>
                    <el-radio :label="2">
                      单次执行
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="Bean名称">
                  <el-input
                    v-model="dialogViewForm.beanName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="Method名称">
                  <el-input
                    v-model="dialogViewForm.methodName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="参数">
                  <el-input
                    v-model="dialogViewForm.params"
                    type="textarea"
                    :autosize="{minRows: 2, maxRows: 5}"
                    resize="none"
                    disabled
                    style="margin-top: -8px;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="Cron表达式">
                  <el-input
                    v-model="dialogViewForm.cronExpression"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="状态">
                  <el-radio-group
                    v-model="dialogViewForm.status"
                    disabled
                  >
                    <el-radio :label="1">
                      正常
                    </el-radio>
                    <el-radio :label="2">
                      暂停
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input
                    v-model="dialogViewForm.remark"
                    type="textarea"
                    resize="none"
                    disabled
                    :autosize="{minRows: 2, maxRows: 5}"
                    style="margin-top: -8px;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogViewVisible = !dialogViewVisible">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin2'
// 自定义Table
import CustomTable from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin2'
// 定时任务API
import { loadScheduleJobListDataApi, saveScheduleJobApi, deleteScheduleJobApi, runScheduleJobApi, pauseScheduleJobApi, resumeScheduleJobApi, viewScheduleJobApi } from '@/api/v2/scheduleJob'

export default {
  name: 'ScheduleJobView',
  components: { TableOperation, CustomTable },
  mixins: [tableCustomMixin, tableOperationMixin],
  data () {
    return {
      masterList: {
        // Table初始化列
        initTableColumn: [],
        // Table列
        tableColumns: [],
        // Table Key
        tableKey: 'schedule_job_table',
        // Table Index
        tableIndex: 0,
        // Table加载状态
        tableLoading: false,
        // Table数据
        tableData: [],
        // Table总数据条数
        tableDataTotal: 0,
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['schedule_job_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['schedule_job_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['schedule_job_run'],
            prop: 'run',
            label: '运行',
            method: 'run'
          },
          {
            permissionSigns: ['schedule_job_pause'],
            prop: 'pause',
            label: '暂停',
            method: 'pause'
          },
          {
            permissionSigns: ['schedule_job_resume'],
            prop: 'resume',
            label: '恢复',
            method: 'resume'
          },
          {
            permissionSigns: ['schedule_job_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['schedule_job_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          type: '',
          beanName: '',
          methodName: ''
        }
      },
      // 新增/修改弹窗
      dialogAddEditTitle: "",
      dialogAddEditVisible: false,
      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        beanName: [
          { required: true, message: "请输入Spring Bean名称", trigger: "blur" },
          { max: 256, message: "长度最多 256 个字符", trigger: "blur" }
        ],
        methodName: [
          { required: true, message: "请输入Spring Method名称", trigger: "blur" },
          { max: 128, message: "长度最多 128 个字符", trigger: "blur" }
        ],
        params: [{ max: 512, message: "长度最多 512 个字符", trigger: "blur" }],
        cronExpression: [
          { required: true, message: "请输入Cron表达式内容", trigger: "blur" },
          { max: 64, message: "长度最多 64 个字符", trigger: "blur" }
        ],
        remark: [{ max: 256, message: "长度最多 256 个字符", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      // 查看弹窗
      dialogViewTitle: "",
      dialogViewVisible: false,
      dialogViewForm: {}
    }
  },
  created () {
    let _this = this
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80, align: 'center' },
      { prop: 'typeValue', label: '类型', filterColumn: "(case type when 1 then '循环执行' when 2 then '单次执行' else '' end)", width: 80 },
      { prop: 'beanName', label: 'Bean名称', filterColumn: 'bean_name', width: 200 },
      { prop: 'methodName', label: '任务方法名称', filterColumn: 'method_name', width: 250 },
      { prop: 'params', label: '参数', filterColumn: 'params', minWidth: 150 },
      { prop: 'cronExpression', label: 'Cron表达式', filterColumn: 'cron_expression', width: 130 },
      { prop: 'remark', label: '备注', filterColumn: 'remark', width: 300 },
      { prop: 'statusValue', label: '状态', filterColumn: "(case status when 1 then '正常' when 2 then '暂停' when 3 then '已执行' else '' end)", width: 80, align: 'center' },
      { prop: 'createTime', label: '创建时间', filterColumn: 'create_time', width: 150, isBetween: true, align: 'center' }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadScheduleJobListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch(() => { })
    },
    // 打开新增弹窗
    handleAdd () {
      let _this = this;
      // 新增/修改 Form
      _this.dialogAddEditForm = {
        id: "",
        type: 1,
        beanName: "",
        methodName: "",
        params: "",
        cronExpression: "",
        remark: ""
      };
      // 显示新增/修改弹窗
      _this.dialogAddEditTitle = '新增';
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible;
      _this.$nextTick(() => {
        // 清除校验提示
        _this.$refs.dialogAddEditForm.clearValidate();
      });
    },
    // 打开修改弹窗
    handleEdit (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的数据', type: 'error' })
        return
      }
      viewScheduleJobApi({ id: args[0].id }).then(response => {
        const { data } = response;
        _this.dialogAddEditForm = {
          id: data.id,
          type: data.type,
          beanName: data.beanName,
          methodName: data.methodName,
          params: data.params,
          cronExpression: data.cronExpression,
          remark: data.remark,
          status: data.status
        };
        // 显示新增/修改弹窗
        _this.dialogAddEditTitle = '修改';
        _this.dialogAddEditVisible = !_this.dialogAddEditVisible;
        _this.$nextTick(() => {
          // 清除校验提示
          _this.$refs.dialogAddEditForm.clearValidate();
        });
      });
    },
    // 关闭新增/修改弹窗
    handleClose () {
      this.dialogAddEditVisible = !this.dialogAddEditVisible;
      this.$refs.dialogAddEditForm.clearValidate();
    },
    // 新增/修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          _this.$confirm("确认保存, 是否继续?", "系统提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", center: true }).then(() => {
            saveScheduleJobApi(_this.dialogAddEditForm).then(() => {
              _this.$message({ type: "success", message: "保存成功" });
              _this.dialogAddEditVisible = !_this.dialogAddEditVisible;
              _this.loadTableData();
            });
          }).catch(() => { });
        } else {
          return false;
        }
      });
    },
    // 运行操作
    handleRun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要立即运行的任务', type: 'error' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '选择的任务不是正常状态，不能运行', type: 'error' })
        return
      }
      _this.$confirm("此操作将立即运行定时任务, 是否继续?", "系统提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", center: true }).then(() => {
        runScheduleJobApi({ id: args[0].id }).then(() => {
          _this.$message({ type: "success", message: "运行成功" });
          _this.loadTableData();
        });
      }).catch(() => { })
    },
    // 暂停操作
    handlePause (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要暂停的任务', type: 'error' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '选择的任务不是正常状态，不能暂停', type: 'error' })
        return
      }

      _this.$confirm("此操作将暂停定时任务, 是否继续?", "系统提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", center: true }).then(() => {
        pauseScheduleJobApi({ id: args[0].id }).then(() => {
          _this.$message({ type: "success", message: "暂停定时任务成功" });
          _this.loadTableData();
        });
      }).catch(() => { })
    },
    // 恢复操作
    handleResume (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要恢复的任务', type: 'error' })
        return
      } else if (args[0].status !== 2) {
        _this.$message({ message: '选择的任务不是暂停状态，不能恢复', type: 'error' })
        return
      }
      _this.$confirm("此操作将恢复定时任务, 是否继续?", "系统提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", center: true }).then(() => {
        resumeScheduleJobApi({ id: args[0].id }).then(() => {
          _this.$message({ type: "success", message: "恢复定时任务成功" });
          _this.loadTableData();
        });
      }).catch(() => { })
    },
    // 作废操作
    handleDelete (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的任务', type: 'error' })
        return
      }
      _this.$confirm("此操作将作废该数据, 是否继续?", "系统提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", center: true }).then(() => {
        deleteScheduleJobApi({ id: args[0].id }).then(() => {
          _this.$message({ type: "success", message: "作废成功" });
          _this.loadTableData();
        });
      }).catch(() => { })
    },
    // 打开查看弹窗
    handleView (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的任务', type: 'error' })
        return
      }
      viewScheduleJobApi({ id: args[0].id }).then((response) => {
        const { data } = response;
        _this.dialogViewForm = data;
        // 显示查看弹窗
        _this.dialogViewTitle = '查看';
        _this.dialogViewVisible = !_this.dialogViewVisible;
      });
    },
  }
}
</script>
